import { useCallback } from "react";
import { i18n } from "@webiny/app/i18n/index.js";
import { useSnackbar } from "@webiny/app-admin";
import { useContainer } from "@webiny/app";
import { GetSettingsRepository } from "~/features/settings/abstractions.js";
import type { FileItem } from "~/domain/types.js";

const t = i18n.ns("app-admin/file-manager/hooks/use-copy-file");

interface UseCopyFileParams {
    file: {
        key: FileItem["key"];
        src?: FileItem["src"];
    };
}

export const useCopyFile = ({ file }: UseCopyFileParams) => {
    const container = useContainer();
    const settingsRepository = container.resolve(GetSettingsRepository);
    const { showSnackbar } = useSnackbar();

    const copyFileUrl = useCallback(() => {
        const fileSrc = file.src || (settingsRepository.settings?.srcPrefix ?? "") + file.key;

        navigator.clipboard.writeText(fileSrc);
        showSnackbar(t`URL copied successfully.`);
    }, [file]);

    return {
        copyFileUrl
    };
};
